import React from 'react';

import { GenericAsyncSelect } from 'src/views/components/select';

const ProjectSelect = ({ projects, ...props }) => {
  const options = projects.map(p => ({
    label: p.label,
    value: p.key,
    icon: p.icon,
  }));

  return (
    <GenericAsyncSelect
      {...props}
      valueFieldName="value"
      placeholder="Select Project..."
      options={options}
      hasIcons
    />
  );
};

export default ProjectSelect;
